import React from "react";
import UploadFile from "../../FormFields/UploadFile";

const MessageA21 = (props) => {
  return <UploadFile {...props} />;
};

export default MessageA21;
